import tracking from '@g4/g4-analytics';

export default label => {
  if (process.browser) {
    tracking.trackEvent('Client Side Error', 'Booking Path', label);
  }
};
